// ======================================================================
// File Name       : ContentHistoryListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { isInvalid, getFormValues, reduxForm } from 'redux-form';
import ContentHistorySearch from '../../../components/userHistory/content/ContentHistorySearch';
import ContentHistorySearchResult from '../../../components/userHistory/content/ContentHistorySearchResult';
import { searchUser } from '../../../actions/archivement/ArchivementAction';
import { getContentList } from '../../../actions/UserHistoryContentAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA, DEFAULT_DATE_FORMAT_SERVER } from '../../../constants/index';
import Header from '../../../components/Header';
import MessageSearch from '../../../components/MessageSearch';
import { DATA_AFFIILIATION_TYPE_STR, DATA_AFFIILIATION_TYPE } from '../../../constants/ContentConstant';
import * as Path from '../../../constants/PathConstants';
import { DATA_AFFILIATION_TYPE } from '../../../constants/ContentHistoryConstant';
import * as actionType from '../../../constants/actionTypes/page';

class ContentHistoryListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        contentSecernId: '',
        contentName: '',
        learningEndTimeFrom: '',
        learningEndTimeTo: '',
        contentType: null,
        dataAffiliationType: '-1',
      },
      itemSortType: -1,
      ascendingDescendingSort: 0,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      isAllowShowSearchMessage: false,
    };

    this.searchData = this.searchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
  }

  goToDetail(contentSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: Path.USER_HISTORY_CONTENT_LIST,
        searchCondition: formValues,
      });
    }
    const path = Path.USER_HISTORY_CONTENT_DETAIL.replace(':id', contentSecernId);
    this.props.history.push(path);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.USER_HISTORY_CONTENT_LIST,
      searchCondition: formValues,
    });
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.itemSortType) {
        column = initialValues.itemSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, column, startPosition);
    this.props.dispatch(getContentList(param.searchInfo, SELECT_TARGET_DATA.DATA)).then(() => {
      this.setState({
        isAllowShowSearchMessage: false,
        filterData: initialValues,
      });
    });
  }

  createParams(data, column, startPosition) {
    const filterData = { ...data };
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.itemSortType = column.sortBy;
    }
    if (data && data.dataAffiliationType) {
      filterData.dataAffiliationType = data.dataAffiliationType;
      if (data.dataAffiliationType === DATA_AFFIILIATION_TYPE.NOT_SELECT) {
        filterData.dataAffiliationType = null;
      }
    }
    if (data && data.learningEndTimeFrom) {
      filterData.learningEndTimeFrom = data.learningEndTimeFrom ? moment(data.learningEndTimeFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER) : '';
    }
    if (data && data.learningEndTimeTo) {
      filterData.learningEndTimeTo = data.learningEndTimeTo ? moment(data.learningEndTimeTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER) : '';
    }

    if (!column) {
      filterData.ascendingDescendingSort = null;
      filterData.itemSortType = null;
    }

    filterData.returnMaxNum = RETURN_MAX_NUM;

    const param = {
      searchInfo: filterData,
    };
    return param;
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      contentSecernId: formValues.contentSecernId,
      contentName: formValues.contentName,
      contentType: formValues.contentType,
      dataAffiliationType: formValues.dataAffiliationType,
      learningEndTimeFrom: formValues.learningEndTimeFrom,
      learningEndTimeTo: formValues.learningEndTimeTo,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      itemSortType: formValues.itemSortType,
      startPosition: formValues.startPosition,
    };
    this.setState({ filterData }, () => {
      let param = null;
      const paramSearch = this.createParams(filterData, null, 0);
      if (paramSearch) {
        param = paramSearch.searchInfo;
      }
      this.props.change('startPosition', 0);
      this.props.change('itemSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(getContentList(param, SELECT_TARGET_DATA.DATA)).then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  searchData(startPosition, column) {
    const { filterData } = this.state;
    const { invalid, dispatch, formValues } = this.props;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(filterData, column, startPosition);
    let param = null;
    if (paramSearch) {
      param = paramSearch.searchInfo;
    }
    this.props.dispatch(getContentList(param, SELECT_TARGET_DATA.DATA)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.itemSortType) {
      column = formValues.itemSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = null;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }
  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { itemList, recordNum, eachItemStatusCount } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={itemList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ContentHistorySearch
          onSearchBtnClick={this.clickSearchButton}
        />
        <ContentHistorySearchResult
          itemListInfo={itemList}
          handleSortState={this.handleSortState}
          eachItemStatusCount={eachItemStatusCount}
          goToDetail={this.goToDetail}
          recordNum={recordNum}
          startPosition={this.state.startPosition}
          getStartEndData={this.getStartEndData}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const invalid = isInvalid('userHistoryContentList')(state);
  const formValues = getFormValues('userHistoryContentList')(state);
  const { parentPath, searchCondition } = state.page;
  const { userHistoryContent } = state;
  const { itemList, recordNum, eachItemStatusCount } = userHistoryContent;

  let initial = {
    contentSecernId: '',
    contentName: '',
    contentType: null,
    dataAffiliationType: -1,
    learningEndTimeFrom: moment().startOf('day').add(-1, 'months'),
    learningEndTimeTo: moment().startOf('day'),
    ascendingDescendingSort: null,
    itemSortType: null,
    startPosition: 0,
    returnMaxNum: RETURN_MAX_NUM,
  };
  if (parentPath === Path.USER_HISTORY_CONTENT_LIST) {
    if (searchCondition) {
      const paramSearch = {};
      paramSearch.contentSecernId = searchCondition.contentSecernId;
      paramSearch.contentName = searchCondition.contentName;
      paramSearch.contentType = searchCondition.contentType;
      paramSearch.dataAffiliationType = searchCondition.dataAffiliationType;
      paramSearch.learningEndTimeFrom = searchCondition.learningEndTimeFrom;
      paramSearch.learningEndTimeTo = searchCondition.learningEndTimeTo;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.itemSortType = searchCondition.itemSortType;
      paramSearch.startPosition = searchCondition.startPosition;
      initial = paramSearch;
    }
  }
  return {
    invalid,
    formValues,
    initialValues: initial,
    itemList,
    recordNum,
    searchCondition,
    eachItemStatusCount,
    userHistoryContent,
  };
};
export default connect(mapStateToProps)(reduxForm({
  form: 'userHistoryContentList',
  enableReinitialize: true,
  touchOnChange: true,
})(ContentHistoryListContainer));
